const privateCacheNames = new Set([
  'pages-cache',
  'maintenances-api-cache',
  'locals-api-cache',
  'equipments-cache',
  'suppliers-cache',
  'periodicities-cache',
  'collaborators-cache',
  'systems-subsystems-cache'
]);

export async function clearPrivateRuntimeCaches(cacheStorage = globalThis.caches) {
  if (!cacheStorage) return;

  const cacheNames = await cacheStorage.keys();
  await Promise.all(cacheNames.filter((cacheName) => privateCacheNames.has(cacheName)).map((cacheName) => cacheStorage.delete(cacheName)));
}
